module.exports = __webpack_public_path__ + "img/right_seven.b6ce1c4a.svg";